import {
  fetchRelatedProductsByCategory,
  selectRelatedProductsByCategory,
  selectRelatedProductsError,
  selectRelatedProductsLoading,
} from "../../redux/slices/relatedProductsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";

import MiniLoader from "../Loader/MiniLoader";
import ScrollContainer from "react-indiana-drag-scroll";
import TopSellerItem from "../Items/TopSellerItem";
import { useTranslation } from "react-i18next";

const RelatedProducts = ({ categoryId }) => {
  const dispatch = useDispatch();

  const loading = useSelector(selectRelatedProductsLoading);

  const error = useSelector(selectRelatedProductsError);

  const relatedProducts = useSelector((state) =>
    selectRelatedProductsByCategory(state, categoryId)
  );

  const{t} = useTranslation();

  useEffect(() => {
    if (categoryId) {
      dispatch(fetchRelatedProductsByCategory(categoryId));
    }
  }, [dispatch, categoryId]);

  const containerRef = useRef(null);
  const [centeredIndex, setCenteredIndex] = useState(0);

  const calculateCenteredIndex = () => {
    if (containerRef.current) {
      const carousel = containerRef.current;
      const items = carousel.querySelectorAll(".carousel-item");
      const viewportCenter = carousel.scrollLeft + carousel.offsetWidth / 4;

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 4;
        const distance = Math.abs(itemCenter - viewportCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }
    return 0;
  };

  const handleScroll = () => {
    const index = calculateCenteredIndex();
    setCenteredIndex(index);
  };

  const goToSlide = (index) => {
    if (containerRef.current) {
      const items = containerRef.current.querySelectorAll(".carousel-item");
      const targetItem = items[index];
      const container = containerRef.current;

      if (targetItem && container) {
        const itemLeft = targetItem.offsetLeft;
        const itemWidth = targetItem.offsetWidth;
        const containerWidth = container.offsetWidth;

        const scrollTo = itemLeft - (containerWidth - itemWidth) / 4;

        container.scrollTo({
          left: scrollTo,
          behavior: "smooth",
        });

        setCenteredIndex(index);
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-[90%]">
      <div className="flex flex-col w-full items-center justify-center relative py-10">
        <div className="w-full relative overflow-hidden mb-8">
          {loading ? (
            <div className="flex items-center justify-center w-full h-full lg:h-[23.68rem] p-5">
              <MiniLoader />
            </div>
          ) : error ? (
            <div className="flex items-center justify-center w-full h-full lg:h-[23.68rem] p-5">
              {t("noRelatedProducts")}
            </div>
          ) : (
            <ScrollContainer
              innerRef={containerRef}
              onScroll={handleScroll}
              draggingClassName="scroll-smooth transition-all ease-in-out"
              className="flex items-start gap-6 w-full overflow-x-auto 
              cursor-grab active:cursor-grabbing"
            >
              {relatedProducts.map((product, index) => (
                <div
                  key={product.id}
                  className="flex items-center justify-center h-full 
                  rounded-2xl carousel-item cursor-auto 
                  "
                >
                  <TopSellerItem
                    product={product}
                    categoryId={product.category_id}
                  />
                </div>
              ))}
            </ScrollContainer>
          )}
        </div>
        <div className="flex lg:hidden gap-2 mb-6 mt-4 w-[80%] px-2">
          {relatedProducts.map((_, i) => (
            <button
              key={i}
              onClick={() => goToSlide(i)}
              className={`h-2 rounded-full transition-all ${
                i === centeredIndex ? "bg-blue-500 w-20" : "bg-gray-400 w-9"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};
export default RelatedProducts;
